import { render, staticRenderFns } from "./MarginHealingPopup.vue?vue&type=template&id=33b6d7e7&"
import script from "./MarginHealingPopup.vue?vue&type=script&lang=js&"
export * from "./MarginHealingPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports